var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"dialog-title":"Storage King Project","dialog-action-button-label":"Save","dialog-action-func":_vm.clickSave,"form-schema":_vm.formSchema,"dataSets":{ costCentreLinks: _vm.costCentreLinks }},model:{value:(_vm.formModel),callback:function ($$v) {_vm.formModel=$$v},expression:"formModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }